import Vue from 'vue'
import Vuex from 'vuex'
import Setting from './Setting/index'
import Ecommerce from './Ecommerce/index'
import apis from '../services/apis'
Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    Setting,
    Ecommerce
  },
  state: {
  },
  mutations: {
  },
  actions: {
    getAllUsers () {
      return new Promise((resolve, reject) => {
        apis.getAllUsers().then(res => {
          resolve(res)
        }).catch(error => {
          console.log(error.response)
          reject(error)
        })
      })
    },
  },
  getters: {
  },
  strict: debug
})
